import styled from "styled-components";
import { RadioButton as PRRadio } from "primereact/radiobutton";
import { compose, color, layout, space } from "styled-system";

const RadioButton = styled(PRRadio).attrs({
  type: "radio",
})`
  box-shadow: none !important;
  ${compose(layout, space, color)};
`;

export default RadioButton;
